module.exports = __webpack_public_path__ + "static/img/right-home-row-6.77118c78.png";